import Container from '@mui/material/Container';
import { useTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useNavigate } from 'react-router-dom';
import { Iconify } from '@mgm/common/components';
import { BaseBreadcrumbs } from '@mgm/common/components/base';
import {
  TeamCommissionsTable,
  DeleteTeamCommission,
  CreateEditTeam,
} from '../../features/commissions/components';
import { PageHelmet } from '../../components';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { commissionsActions } from '../../store/commissions/slice';
import { useAppDispatch } from '../../hooks/useAppStore';
import { TCommissionTeam } from '../../types';
import { ROUTES } from '../../data';

const CommissionTeams = () => {
  const { t } = useTranslation(['commissions', 'team']);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const navigateToCommissionModel = () => {
    navigate(ROUTES.COMMISSION_MODELS);
  };

  const handleCreateTeamCommission = () => {
    dispatch(commissionsActions.setIsOpenTeamCommissionsNav(true));
    dispatch(commissionsActions.setSelectedTeam({} as TCommissionTeam));
  };

  return (
    <PageHelmet title={PAGES_ANALYTICS_TITLES.COMMISSIONS_TEAMS}>
      <Container
        sx={{
          px: { xs: 0, lg: 1 },
        }}
        maxWidth={false}
      >
        <BaseBreadcrumbs
          heading={t('commissionTeams')}
          links={[
            { name: t('commissions'), href: '/commissions/plans' },
            { name: t('commissionTeams'), href: '/commissions/teams' },
          ]}
          action={(
            <Stack spacing={2} direction="row" alignItems="center" justifyContent="flex-end">
              <Button
                startIcon={(
                  <Iconify icon="cuida:help-outline" width={20} sx={{ color: '#A855F7' }} />
          )}
                onClick={navigateToCommissionModel}
                variant="outlined"
              >
                {t('commissionModel', { ns: 'commissions' })}
              </Button>
              <Button onClick={handleCreateTeamCommission} variant="contained">{t('addTeam', { ns: 'team' })}</Button>
            </Stack>
          )}
        />
        <TeamCommissionsTable />
        <DeleteTeamCommission />
        <CreateEditTeam />
      </Container>
    </PageHelmet>
  );
};

export default CommissionTeams;
